import React, { useRef, useState, useEffect } from 'react';
import { motion, useInView } from 'framer-motion';
import backgroundVideo from '../assets/img/about/TableSet.mp4';
import image1 from '../assets/img/about/Google.png';
import image2 from '../assets/img/about/Stripe-Emblem.png';
import image3 from '../assets/img/about/Twilio.png';

const highlights = [
  {
    header: 'Stripe Connect Payments',
    image: image2,
    text: 'Account Setup With Seemless Built In Transactions and Full Visbility of Financial Reports On Stripe Platform'
  },
  {
    header: 'Your Google Business Profile',
    image: image1,
    text: 'Gohost App is Programmed to Instantly Adjust Your GBP. Only One Step to Change: Hours, Dates, Address and Contact Info'
  },
  {
    header: 'Reservation Texts with Twilio',
    image: image3,
    text: 'GoHost Authenticates Numbers, Prevents DoubleBooking, and Uses Twilio to Confirm Reservations Details'
  }
];

export default function ThreeHighlights() {
  // Attach a ref and useInView hook to trigger animations when 70% of the container is visible.
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.7 });

  // Check if device is mobile (width < 768px).
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);

  // Animation variants (used only for non-mobile devices).
  const contentVariants = {
    hidden: { opacity: 0 },
    animate: (custom) => ({
      opacity: 1,
      transition: { delay: custom * 0.3 + 0.8, duration: 0.3 }
    })
  };

  const imageVariants = {
    hidden: { x: '-100vw', rotate: 15 },
    animate: (custom) => ({
      x: 0,
      rotate: [0, 15, 0],
      transition: {
        x: { delay: custom * 0.2, type: 'spring', stiffness: 90 },
        rotate: { delay: custom * 0.4, duration: 0.6 }
      }
    })
  };

  return (
    <div className="relative overflow-hidden select-none p-[50px]">
      {/* Background Video */}
      <video 
        autoPlay 
        loop 
        muted 
        playsInline 
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
      >
        <source src={backgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Gradient overlay at the top */}
      <div 
        className="absolute top-0 left-0 w-full h-4/5"
        style={{
          background: 'linear-gradient(to bottom, rgba(253,253,251,1) 0%, rgba(253,253,251,0.99) 15%, rgba(253,253,251,0) 100%)',
          zIndex: 5
        }}
      />

      {/* Gradient overlay at the bottom */}
      <div 
        className="absolute bottom-0 left-0 w-full h-2/3"
        style={{
          // background: 'linear-gradient(to top, rgba(253,253,251,1) 0%, rgba(253,253,251,0) 100%)',
          background: 'linear-gradient(to top, rgba(253,253,251,1) 0%, rgba(253,253,251,0.95) 30%, rgba(253,253,251,0) 100%)',
          zIndex: 5
        }}
      />

      {/* Highlights Content */}
      <div className="relative z-10 p-4" ref={ref}>
        <div className=" bg-white/50 backdrop-blur-xl rounded-2xl pt-8 pb-4 w-full max-w-[500px] mx-auto text-center"
                    style={{
                      backgroundImage: `
      linear-gradient(to top, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%),
      linear-gradient(to bottom, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%),
      linear-gradient(to left, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%),
      linear-gradient(to right, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%)
    `,
    backgroundBlendMode: 'screen',
                      WebkitMaskImage: `
                        linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 20%, rgba(0,0,0,1) 80%, rgba(0,0,0,0) 100%),
                        linear-gradient(to left, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 8%, rgba(0,0,0,1) 92%, rgba(0,0,0,0) 100%)
                      `,
                      WebkitMaskComposite: 'destination-in',
                      maskComposite: 'intersect',
                      WebkitMaskSize: '100% 100%',
                      maskSize: '100% 100%',
                      WebkitMaskRepeat: 'no-repeat',
                      maskRepeat: 'no-repeat',
                    }}>
        <h2 className="text-center h2 text-red-900 font-bold  mb-2">Automatic Setup</h2>
        <p className='text-center pretitle text-neutral-900 mb-8'>So you can focus on setting the table</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {highlights.map((item, index) => {
            // Reverse order: rightmost (index 2) animates first.
            const order = highlights.length - 1 - index;
            return (
              <div key={index} className="flex flex-col items-center">
                {isMobile ? (
                  // For mobile, render text and image without any animation.
                  <>
                  <img
                      src={item.image}
                      alt={item.header}
                      className="w-[100px] h-auto rounded z-30"
                      style={{ transformOrigin: '100% 100%' }}
                    />
                    {/* <div className="mt-2 text-center"> */}
                    <div className="mt-2 text-center bg-white/20 backdrop-blur-xl rounded-3xl px-8 py-4"
                    style={{
                      backgroundImage: `
      linear-gradient(to top, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%),
      linear-gradient(to bottom, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%),
      linear-gradient(to left, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%),
      linear-gradient(to right, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%)
    `,
    backgroundBlendMode: 'screen',
                      WebkitMaskImage: `
                        linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%),
                        linear-gradient(to left, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 15%, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%)
                      `,
                      WebkitMaskComposite: 'destination-in',
                      maskComposite: 'intersect',
                      WebkitMaskSize: '100% 100%',
                      maskSize: '100% 100%',
                      WebkitMaskRepeat: 'no-repeat',
                      maskRepeat: 'no-repeat',
                    }}>
                      <h3 className="h2 text-red-900 text-2xl font-bold mb-2">{item.header}</h3>
                      <p className="text-neutral-900 mb-6 ">{item.text}</p>
                    </div>
                    
                  </>
                ) : (
                  // On non-mobile devices, apply animations via Framer Motion.
                  <>
                  <motion.img
                      src={item.image}
                      alt={item.header}
                      className="w-[120px] h-[115px] rounded mb-6 mt-6"
                      custom={order}
                      variants={imageVariants}
                      initial="hidden"
                      animate={isInView ? "animate" : "hidden"}
                      style={{ transformOrigin: '100% 100%' }}
                    />
                    <motion.div 
                      className=" bg-white/50 backdrop-blur-md rounded-3xl p-4  w-auto text-center"
                      style={{
                        backgroundImage: `
        linear-gradient(to top, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%),
        linear-gradient(to bottom, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%),
        linear-gradient(to left, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%),
        linear-gradient(to right, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 40%)
      `,
      backgroundBlendMode: 'screen',
                        WebkitMaskImage: `
                          linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%),
                          linear-gradient(to left, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 90%, rgba(0,0,0,0) 100%)
                        `,
                        WebkitMaskComposite: 'destination-in',
                        maskComposite: 'intersect',
                        WebkitMaskSize: '100% 100%',
                        maskSize: '100% 100%',
                        WebkitMaskRepeat: 'no-repeat',
                        maskRepeat: 'no-repeat',
                      }}
                      custom={order}
                      variants={contentVariants}
                      initial="hidden"
                      animate={isInView ? "animate" : "hidden"}
                    >
                      <h3 className="h2 text-red-900 text-2xl font-bold mb-2">{item.header}</h3>
                      <p className="text-neutral-900 mb-6 max-w-[460px]">{item.text}</p>
                    </motion.div>
                    
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
